export default class Storage {
    static driver () {
        if (typeof window === 'undefined') {
            return new Proxy({}, { get: () => () => null });
        }
        return self.localStorage || new Proxy({}, { get: () => () => null });
    }

    /**
     * Set the value of the given key.
     *
     * @param  {string}  key
     * @param  {mixed}  value
     * @return {void}
     */
    static set(key, value)
    {
        const driver = this.driver();
        const stringifiedValue = JSON.stringify(value);
        
        try {
            driver.setItem(key, stringifiedValue);
        } catch (error) {
            // Handle quota exceeded error by removing items with '[' in key name and retrying
            if (error.name === 'QuotaExceededError' || error.code === 22) {
                try {
                    // Remove all items that have '[' in their key name to free up space
                    const keysToRemove = [];
                    for (let i = 0; i < driver.length; i++) {
                        const storageKey = driver.key(i);
                        if (storageKey && storageKey.includes('[')) {
                            keysToRemove.push(storageKey);
                        }
                    }
                    keysToRemove.forEach(keyToRemove => driver.removeItem(keyToRemove));
                    
                    // Retry setting the new value
                    driver.setItem(key, stringifiedValue);
                } catch (retryError) {
                    // If retry still fails, throw the original error
                    throw error;
                }
            } else {
                // Re-throw other errors
                throw error;
            }
        }
    }

    /**
     * Get the value of the given key.
     *
     * @param  {string}  key
     * @param  {mixed}  value
     * @return {mixed}
     */
    static get(key, value = null)
    {
        return JSON.parse(this.driver().getItem(key)) || value;
    }

    /**
     * Determine if the key exists.
     *
     * @param  {string}  key
     * @return {bool}
     */
    static has(key)
    {
        return !! this.get(key);
    }

    /**
     * Remove the value of the given key.
     *
     * @param  {string}  key
     * @return {void}
     */
    static remove(key)
    {
        this.driver().removeItem(key);
    }

    /**
     * Flush all the data.
     *
     * @return {void}
     */
    static clear()
    {
        this.driver().clear();
    }
}
